// Apply moderated {ctrl}.params onto the optimistic buffer row (onCtrlMessage runs before publish resolves).
export function applyTinodeModerationPubPatch(tinode) {
  if (!tinode || tinode._moderationPubPatchApplied) {
    return;
  }
  tinode._moderationPubPatchApplied = true;
  const prev = tinode.onCtrlMessage;
  tinode.onCtrlMessage = function(ctrl) {
    syncModeratedPubFromCtrl(tinode, ctrl);
    if (typeof prev === 'function') {
      prev.call(tinode, ctrl);
    }
  };
}

function coerceCtrlContent(raw) {
  if (raw != null && typeof raw === 'object') {
    return raw;
  }
  if (typeof raw === 'string' && raw.length > 0 && raw.charAt(0) === '{') {
    try {
      return JSON.parse(raw);
    } catch (_) {
      /* keep string */
    }
  }
  return raw;
}

function syncModeratedPubFromCtrl(tinode, ctrl) {
  if (!ctrl || ctrl.code < 200 || ctrl.code >= 300) {
    return;
  }
  if (!ctrl.params || ctrl.params.content === undefined) {
    return;
  }
  if (ctrl.params.seq == null || ctrl.id == null || !ctrl.topic) {
    return;
  }
  const topic = tinode.getTopic(ctrl.topic);
  const buf = topic && topic._messages && topic._messages.buffer;
  if (!Array.isArray(buf)) {
    return;
  }
  const want = String(ctrl.id);
  let target = null;
  for (let i = buf.length - 1; i >= 0; i--) {
    const m = buf[i];
    if (m && String(m.id) === want) {
      target = m;
      break;
    }
  }
  if (!target) {
    return;
  }
  target.content = coerceCtrlContent(ctrl.params.content);
  if (ctrl.params.head !== undefined) {
    target.head = Object.assign({}, target.head || {}, ctrl.params.head);
  }
}
